import loadConfig from "../loadConfig";

export default async function() {
  let error: Error = new Error("default error");

  for (let i = 0; i < 3; i++) {
    try {
      await loadConfig();
      let { createApp } = await import("./");
      return { app: createApp() };
    } catch (e) {
      error = e;
      await new Promise(r => setTimeout(r, 1000));
    }
  }

  let { createErrorApp } = await import("./createError");
  return { app: createErrorApp(error) };
}
